import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { ProductMockup } from './ProductMockup';

export function HeroSection(): JSX.Element {
  return (
    <section className='relative overflow-hidden pt-32 pb-20 md:pt-40 md:pb-28'>
      {/* Subtle background accent */}
      <div className='absolute top-0 right-0 -z-10 h-[600px] w-[600px] rounded-full bg-teal/10 blur-3xl' />

      <div className='mx-auto max-w-6xl px-6'>
        <div className='grid items-center gap-12 lg:grid-cols-2 lg:gap-16'>
          {/* Left: Copy */}
          <div className='max-w-xl'>
            <div className='mb-6 inline-flex items-center gap-2 rounded-full border border-border bg-muted px-4 py-1.5'>
              <div className='h-1.5 w-1.5 rounded-full bg-teal' />
              <span className='text-xs font-semibold uppercase tracking-widest text-muted-foreground'>
                Lease Risk Monitoring
              </span>
            </div>

            <h1
              className='text-4xl font-bold leading-tight tracking-tight text-foreground md:text-5xl lg:text-[3.5rem] text-balance'
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Every Lease Right Is a Financial Obligation.
            </h1>

            <p className='mt-6 text-lg leading-relaxed text-muted-foreground text-pretty'>
              {'Track option windows, ROFRs, renewals, expansions, and CAM caps across your portfolio \u2014 in one centralized system.'}
            </p>

            <p className='mt-3 text-sm text-muted-foreground/70'>
              Built for third-party firms managing large commercial lease portfolios.
            </p>

            <div className='mt-10 flex flex-wrap items-center gap-4'>
              <Button
                asChild
                size='lg'
                className='rounded-full bg-foreground px-8 text-background hover:bg-foreground/90 text-sm font-medium h-12'
              >
                <Link to='/requestdemo'>
                  Request a Demo
                  <ArrowRight className='ml-1 h-4 w-4' />
                </Link>
              </Button>
            </div>
          </div>

          {/* Right: Product Mockup */}
          <div className='relative'>
            <ProductMockup className='lg:ml-4' />
            {/* Decorative teal dot */}
            <div className='absolute -bottom-4 -left-4 h-24 w-24 rounded-full bg-teal/20 blur-2xl' />
          </div>
        </div>
      </div>
    </section>
  );
}
